module.exports = __webpack_public_path__ + "media/seher_1.1h.e78911f2.mp3";